<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
    >
        <v-form
        ref="attacmentForm"
        lazy-validation>
        <v-card>
            <v-card-text style="height: 300px;">
            <div v-cloak @drop.prevent="addDropFile" @dragover.prevent style="border-style:dashed;border-color:#D3D3D3;height: 250px;">
                    <v-file-input :disabled="newInvoice.statusId != 2 && newInvoice.statusId != 21"
                        v-model="currentFile"
                        multiple
                        v-bind:placeholder="$t('chooseFile')"
                        prepend-icon="mdi-paperclip"
                        accept=".pdf"
                        @change="addFiles"
                        @click:clear="clearFileInput()"
                        :rules="fileSizeRule"
                    >
                        <template v-slot:selection="{ index, text }">
                        <v-chip
                            v-if="index < 2"
                            label
                            small
                            outlined
                        >
                            {{ text }}
                        </v-chip>

                        <span
                            v-else-if="index === 2"
                            class="text-overline grey--text text--darken-3 mx-2"
                        >
                            +{{ newInvoice.files.length - 2 }} {{ $t ('file') }} Datoteka(e)
                        </span>
                        </template>
                    </v-file-input>
                    <div v-if="newInvoice.files.length">
                        <v-chip-group column>
                                <v-chip v-for="(file, index) in newInvoice.files" :key="index" 
                                close outlined class="text-wrap"
                                @click="openFile(file)"
                                @click:close="removeFromFiles(index)">
                                    {{ file.name }} ({{ formatBytes(file.size) }})
                                </v-chip>
                        </v-chip-group>
                    </div>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">
            <v-btn
                color="blue darken-1"
                text
                @click="closeDialog"
            >
                {{ $t('close') }}
            </v-btn>
            </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    name: "UploadAttachment",
    props: ['newInvoice'],
    data () {
      return {
        dialog: this.$parent.showAttachment,
        currentFile: this.$parent.currentFile
      }
    },
    computed: {
        fileSizeRule() {
            const rules = []
            if(this.newInvoice.files && this.newInvoice.files.length > 0) {
                var rule = this.newInvoice.files.every(file => file.name.endsWith('.pdf')) || this.$t('pdfOnly')
                rules.push(rule) 
                rule = this.newInvoice.files.some(file => file.size < 26214400) || this.$t('fileSize')
                rules.push(rule) 
                rule = this.newInvoice.files.length <= 3 || this.$t('fileCount')
                rules.push(rule) 
            }
            return rules
        }
    },
    methods: {
        validation() {
            return this.$refs.attacmentForm.validate()
        },
        addFiles() {
            this.newInvoice.files.push(...this.currentFile) 
        },
        addDropFile(e) { 
            this.newInvoice.files.push(...Array.from(e.dataTransfer.files)) 
        },
        removeFromFiles(index) {
            if(this.newInvoice.statusId == 2 || this.newInvoice.statusId == 21)
                this.newInvoice.files.splice(index, 1)
        },
        formatBytes(bytes,decimals=2,k=1024) {
            if (bytes === 0) 
                return '0 Bytes';
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        clearFileInput() {
            this.newInvoice.files = JSON.parse(JSON.stringify(this.initialInvoice.files))
        },
      closeDialog() {
          if(this.validation())
            this.$parent.showAttachment = false
      },
      openFile(file) {
          var formData = new FormData();
          formData.append('file', file);
          formData.append('path', JSON.stringify(file.path));

          this.axios.post('SalesInvoices/OpenAttachment', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }, responseType: 'arraybuffer',
              }).then(response => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            window.open(fileURL, '_blanck')
              }, (error) => {
                              console.log("Error: " + error);
                              console.log(error);
              })
      }
    }
  }
</script>